import React from "react"

import Navigation from "../components/navigation"
import Image from "../components/image"
import SEO from "../components/seo"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const IndexPage = () => (
  <div>
    <SEO title="Home" keywords={[`UI`, `UX`, `product`]}/>
    
    <Navigation />
    <Container className='my-3'>
      <Row className='my-4'>
      <Col xs='12' md='6'className='align-self-center' ><h1>"The experience of being human and being alive is what is at the core of every successful product."</h1></Col>
      <Col xs='12' md='6'>
        <div style={{ maxWidth: `100%`, margin: `1.45rem` }} className='homeimage'>
      <Image style={{color:'#989898'}}/>
    </div>
    </Col>
    </Row>
    <Row >
      <Col> <h6 className='my-4'>
    Hello, I'm <strong>Naren Katakam </strong>and I'm a kick-ass design leader and an equally bad-ass product leader from Singapore. My specialty is in gathering little bits of information from people and then weaving these bits together with design elements to make products that solve a problem.
    </h6>
    <h6 className='my-4'> To me, this is the core essence of building better products.</h6>
    </Col>
    </Row>
    </Container>     
    
  </div>
)

export default IndexPage
